import { useState } from 'react'

import './color-filed.styles.css'

const ColorFiled = ({ colors, onColorSelect }) => {
  const [selectedColorId, setSelectedColorId] = useState(null)

  // مدیریت انتخاب رنگ
  const handleColorSelect = (color) => {
    setSelectedColorId(color.id) // ذخیره فقط id رنگ
    onColorSelect(color.id) // ارسال فقط id به کامپوننت والد
  }

  return (
    <div className='color-picker-container'>
      <h3>انتخاب رنگ محصول</h3>
      <div className='color-options'>
        {colors.map((color) => (
          <div
            className={`color-option ${
              selectedColorId === color.id ? 'selected' : ''
            }`}
            key={color.id}
            onClick={() => handleColorSelect(color)}
          >
            <p className='color-label'>{color.color}</p>{' '}
            {/* نمایش نام فارسی رنگ */}
            {selectedColorId === color.id && (
              <span className='checkmark'>✔</span>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ColorFiled
